import { render, staticRenderFns } from "./LmColumnMenu.vue?vue&type=template&id=1aa4ba6c"
import script from "./LmColumnMenu.vue?vue&type=script&lang=js"
export * from "./LmColumnMenu.vue?vue&type=script&lang=js"
import style0 from "./LmColumnMenu.vue?vue&type=style&index=0&id=1aa4ba6c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports